import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import MarkdownIt from 'markdown-it';
import MarkdownItAttrs from 'markdown-it-attrs';

import MdContent from '@frolight/components/MdContent';
import { getLocalizedRichTextContent } from '@frolight/services/localizationService';

const md = new MarkdownIt({html: true}).use(MarkdownItAttrs);


const useLocalizedFormattedText = () => {
  const { t } = useTranslation();

  const lftext = (key, options) => {
    const translation = t(key, options);
    if (translation.startsWith('%MD_TEXT%')) {
      const markdownContent = translation.replace('%MD_TEXT%', '');
      return <MdContent content={md.render(markdownContent)} />;
    }

    if (translation.startsWith('%MD_FILE%')) {
      const filePath = translation.replace('%MD_FILE%', '');
      const [markdownContent, setMarkdownContent] = useState(null);

      useEffect(() => {
        const fetchMarkdown = async () => {
            const text = await getLocalizedRichTextContent(filePath);
            setMarkdownContent(text);
        }
        fetchMarkdown();
      }, [filePath]);

      if (markdownContent === null) return 'Loading...';
      return <MdContent content={md.render(markdownContent)} />;
    }

    return translation;
  };

  return { lftext };
};

export default useLocalizedFormattedText;
